import { useMutation, useQueryClient } from "@tanstack/react-query"
import type { User } from "@/entities/user"
import { updateUser, userQueryOptions } from "@/entities/user"
import type { CharacterType } from "../model/types"
import { characterKeys } from "./keys"

interface UpdateCharacterArgs {
	userId: number
	character: CharacterType
}

export function useUpdateCharacter() {
	const queryClient = useQueryClient()

	return useMutation<User, Error, UpdateCharacterArgs>({
		mutationKey: characterKeys.update(),
		scope: { id: "update-character" },
		mutationFn: ({ userId, character }) =>
			updateUser({ id: userId, character }),
		onMutate: async ({ userId, character }) => {
			const { queryKey } = userQueryOptions(userId)
			await queryClient.cancelQueries({ queryKey })

			const user = queryClient.getQueryData(queryKey)
			if (!user) return

			queryClient.setQueryData(queryKey, { ...user, character })
		},
		onSettled: (_data, _error, { userId }) => {
			if (queryClient.isMutating({ mutationKey: characterKeys.update() }) !== 1)
				return
			const { queryKey } = userQueryOptions(userId)
			queryClient.invalidateQueries({ queryKey })
		},
	})
}
